import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
// export function _queryOrders(
//   {
//     startAt,
//     endAt,
//     status,
//     telephone,
//     page,
//     size,
//     direction,
//     sort,
//     userId,
//     orderNo,
//     id,
//     name,
//     goodsName,
//     isWDTSync,
//   },
// ) {
//   return fetch({
//     url: `${process.env.VUE_APP_BASE_URL}/orders`,
//     method: 'get',
//     params: {
//       startAt,
//       endAt,
//       status,
//       telephone,
//       page,
//       size,
//       direction,
//       sort,
//       userId,
//       id,
//       orderNo,
//       name,
//       goodsName,
//       isWDTSync,
//     },
//   });
// }

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryOrders(
  {
    startAt,
    endAt,
    ageStart,
    ageEnd,
    amountStart,
    amountEnd,
    area,
    status,
    telephone,
    page,
    size,
    direction,
    sort,
    userId,
    orderNo,
    id,
    name,
    goodsName,
    isWDTSync,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/orders`,
    method: 'get',
    params: {
      startAt,
      endAt,
      ageStart,
      ageEnd,
      amountStart,
      amountEnd,
      area,
      status,
      telephone,
      page,
      size,
      direction,
      sort,
      userId,
      id,
      orderNo,
      name,
      goodsName,
      isWDTSync,
    },
  });
}

export function _redirect() {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/orders`,
    method: 'post',
    params: {},
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryOrderPosition(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/orders/${orderId}/position`,
    method: 'get',
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryOrder(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/orders/${orderId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  goodsSkuId
 * @param  quantity
 * @param  amount
 * @param  userId
 * @param  status
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addOrder(
  {
    goodsSkuId,
    quantity,
    amount,
    userId,
    status,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/orders`,
    method: 'post',
    data: {
      goodsSkuId,
      quantity,
      amount,
      userId,
      status,
    },
  });
}

/**
 * 更新
 * @param orderId
 * @param  goodsSkuId
 * @param  quantity
 * @param  amount
 * @param  userId
 * @param  status
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateOrder(orderId, {
  goodsSkuId,
  quantity,
  amount,
  userId,
  status,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/orders/${orderId}`,
    method: 'patch',
    data: {
      goodsSkuId,
      quantity,
      amount,
      userId,
      status,
    },
  });
}

/**
 * 更新
 * @param orderId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _cancelOrder(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/orders/${orderId}/cancel`,
    method: 'patch',
  });
}

/**
 * 更新
 * @param orderId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _unShippedOrder(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/orders/${orderId}/un-shipped`,
    method: 'patch',
  });
}

/**
 * 更新
 * @param orderId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _shippedOrder(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/orders/${orderId}/shipped`,
    method: 'patch',
  });
}

/**
 * 更新
 * @param orderId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _completedOrder(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/orders/${orderId}/completed`,
    method: 'patch',
  });
}

/**
 * 删除
 * @param orderId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteOrder(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/orders/${orderId}`,
    method: 'delete',
  });
}

/**
 * 删除
 * @param orderId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _refundOrder(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/orders/${orderId}/refund`,
    method: 'post',
  });
}

/**
 * 删除
 * @param orderId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _queryRefundOrders(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/orders/${orderId}/refund-orders`,
    method: 'get',
  });
}

/**
 * 更新
 * @param  orderId
 * @param  city
 * @param  name
 * @param  district
 * @param  address
 * @param  province
 * @param  zipCode
 * @param  mobile
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateOrderDeliverInfo(orderId, {
  city,
  name,
  district,
  address,
  province,
  zipCode,
  mobile,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/orders/${orderId}/deliver-info`,
    method: 'patch',
    data: {
      city,
      name,
      district,
      address,
      province,
      zipCode,
      mobile,
    },
  });
}

/**
 * 删除
 * @param orderId
 * @param refundData
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _refundOrderDetail(orderId, refundData) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/orders/${orderId}/refund/data`,
    method: 'post',
    data: refundData,
  });
}

/**
 * wdt 同步
 * @param orderId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _syncWDT(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/orders/${orderId}/sync-wdt`,
    method: 'post',
  });
}

/**
 * 备注
 * @param orderId
 * @param remark
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateOrderRemark(orderId, { remark }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/orders/${orderId}/refund`,
    method: 'patch',
    data: {
      remark,
    },
  });
}

/**
 * 查询订单记录
 * @param orderId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _queryOrderRecords(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/orders/${orderId}/records`,
    method: 'get',
  });
}

export default {};
